import { TransactionType } from "@gymflow/types";

import { RevenueCategoryKey, RevenueCategoryType } from "./types";

export const REVENUE_CATEGORY_MAP: Record<
  RevenueCategoryKey,
  RevenueCategoryType
> = {
  Membership: "MEMBERSHIP",
  CreditPack: "CREDIT_PACK",
  Product: "PRODUCT_ORDER",
};

export const TRANSACTION_TYPE_DISPLAY_MAP: Partial<
  Record<TransactionType, string>
> = {
  CREDIT: "Payment",
  REFUND_DEBIT: "Refund",
};
